import { render, staticRenderFns } from "./ServiceShow.vue?vue&type=template&id=4fdb593e&"
import script from "./ServiceShow.vue?vue&type=script&lang=js&"
export * from "./ServiceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports